














export default

	props:
		block: Object
		balanceText:
			type: Boolean
			default: true

	computed:
		cards: -> @block.cards || []

		classes: -> [
			# desktopColumns is a number between 3-4
			"desktop-columns-#{@block.desktopColumns or 4}"
			"layout-#{@block.layout}"
		]

